import Vue from "vue";
import vuetify from "../vuetify";
import ModalMessage from "./components/ModalMessage.vue";

declare module "vue/types/vue" {
  interface Vue {
    $alert: Function;
    $confirm: Function;
  }
}

const modalAlert = async (title: string, message: string) => {
  return new Promise(resolve => {
    const VM = Vue.extend(ModalMessage);
    new VM({
      propsData: {
        title: title,
        message: message,
        okAction: () => resolve(true)
      },
      vuetify
    });
  }).catch(err => {
    console.log(err);
  });
};

const modalConfirm = async (title: string, message: string) => {
  return new Promise(resolve => {
    const VM = Vue.extend(ModalMessage);
    new VM({
      propsData: {
        title: title,
        message: message,
        okAction: () => resolve(true),
        cancelAction: () => resolve(false)
      },
      vuetify
    });
  }).catch(err => {
    console.log(err);
  });
};

export default {
  install(Vue: any) {
    Vue.prototype.$alert = modalAlert;
    Vue.prototype.$confirm = modalConfirm;
  }
};
